import * as Sentry from '@sentry/nextjs';

export function getSentry() {
  return Sentry;
}
